import { loadTerms } from 'actions/terms';

export default dispatch => ({
  loadTerms: () => dispatch(loadTerms()),
});
